<template>
    <PopupWindow
        v-if="isVisiblePopup"
        :key="modal"
        :popupName="modal.popupName"
        :header="modal.header"
        :info="modal.info"
        :buttonText="modal.button"
        :callback="modal.callback"
        :orderData="order"
        :buttonText2="modal.button2"
        :color="modal.color"
    ></PopupWindow>
    <div class="container">
        <div class="editing_container">
            <div class="editing_container__header">
                <div style="display: flex; justify-content: space-between; width: 100%">
                    <span class="header__leftside">
                        <h1 style="display: flex; font-size: 22px">
                            <div class="">
                                Заказ {{ order.id }} от
                                {{ tools.formatTimestamp(order.date_created, 'number', 'dd MMMM YYYY') }}
                                <span class="leftside__statusBar"
                                    ><div
                                        class="leftside__statusBarInner"
                                        :style="{ width: progressBarForStatus(order.status) + '%' }"
                                    ></div
                                ></span>
                            </div>
                            <div class="buttons_container">
                                <div class="row">
                                    <button
                                        @click="printOrder()"
                                        class="btn-reset btn btn_emoji small button_func"
                                        type="submit"
                                    >
                                        🖨️
                                    </button>
                                </div>
                                <div class="row">
                                    <button
                                        @click="editingOrder()"
                                        class="btn-reset btn btn_emoji small button_func"
                                        type="submit"
                                    >
                                        ✍🏻
                                    </button>
                                    <button
                                        @click="removeOrder()"
                                        class="btn-reset btn btn_emoji small button_func"
                                        type="submit"
                                    >
                                        🗑️
                                    </button>
                                </div>
                            </div>
                        </h1>
                        <div id="ab_print" style="position: absolute; margin-top: 3.5%">
                            <p style="display: flex; margin-top: 40px">
                                {{ order.price != -1 ? `${order.price} руб.` : '' }}
                            </p>
                            Текущий статус: {{ tools.statusToString(order.status) }}
                            <span style="display: flex; margin-top: 10px">
                                <label
                                    v-if="order.status > 1"
                                    style="display: grid; text-align: center; align-content: center; background: none"
                                    class="btn_emoji"
                                >
                                    {{ order.istg ? '📱' : '🗔' }}
                                </label>
                                <button
                                    @click="alertOrder()"
                                    class="btn-reset btn btn_emoji small order_buttons"
                                    type="submit"
                                >
                                    🔔
                                </button>
                                <button
                                    v-if="order.status == 2"
                                    style="margin-top: 5px"
                                    @click="changeStatusOrder(2)"
                                    class="btn-reset btn btn_blue small order_buttons"
                                    type="submit"
                                >
                                    В работе
                                </button>
                                <button
                                    v-if="order.status == 4"
                                    style="margin-top: 5px"
                                    @click="changeStatusOrder(2)"
                                    class="btn-reset btn btn_blue small order_buttons"
                                    type="submit"
                                >
                                    Выполнен
                                </button>
                                <button
                                    v-if="order.status < 5"
                                    @click="cancelOrder()"
                                    style="margin-top: 5px"
                                    class="btn-reset btn btn_cancel small order_buttons"
                                    type="submit"
                                >
                                    Отменить
                                </button>
                            </span>
                        </div>
                    </span>
                    <span class="header__rightside">
                        <p>Москва, {{ tools.formatDate(new Date(), 'dd Mmm YYYY') }}</p>
                        <h2>{{ tools.formatDate(new Date(), 'hh:mm') }} (UTC +3:00)</h2>
                    </span>
                </div>
            </div>
            <div class="editing_container__body">
                <div class="body__infoContainer">
                    <span class="infoContainer_data">
                        <label class="header">Контактное лицо</label>
                        <div class="info" v-if="order.customer">
                            <span class="data">{{ order.contactName }}</span>
                            <span class="data">{{ order.contactPhone }}</span>
                        </div>

                        <label style="margin-top: 25%" class="header">Заказчик</label>
                        <div class="info" v-if="order.customer">
                            <span class="data">{{ order.customer.fullname }}</span>
                            <span class="data">{{ order.customer.phone }}</span>
                        </div>
                    </span>

                    <span class="infoContainer_data">
                        <label class="header">Пациент</label>
                        <div class="info">
                            <span class="data"
                                ><a style="width: 150px">Вес</a><a style="font-weight: 600">{{ order.weight }}</a></span
                            >
                            <span class="data"
                                ><a style="width: 150px">Пол</a><a style="font-weight: 600">{{ order.gender }}</a></span
                            >
                            <span class="data"
                                ><a style="width: 150px">Возраст</a
                                ><a style="font-weight: 600">{{ order.age }}</a></span
                            >
                            <span class="data"
                                ><a style="width: 150px">Состояние</a
                                ><a style="font-weight: 600">{{ order.state }}</a></span
                            >
                            <span class="data"
                                ><a style="width: 150px">Мобильность</a
                                ><a style="font-weight: 600">{{ order.mobility }}</a></span
                            >
                        </div>
                    </span>

                    <span id="comms_print" class="infoContainer_data">
                        <label class="header">Заметки</label>
                        <div class="info">
                            <span class="data">{{ order.comment }}</span>
                        </div>
                    </span>
                </div>
                <div class="body__infoContainer"></div>

                <div class="body__infoContainer">
                    <span class="infoContainer_data">
                        <label class="header">Исполнитель</label>
                        <div class="info" v-if="order.executor">
                            <span class="data">{{ order.executor.fullname }}</span>
                            <span class="data">{{ order.executor.phone }}</span>
                        </div>
                    </span>

                    <span class="infoContainer_data">
                        <label class="header">Подача ТС</label>
                        <div class="info" style="display: flex; flex-flow: row; align-items: center">
                            <span class="data" style="width: 325px; line-height: 25px; height: 50px">{{
                                tools.formatTimestamp(order.date_start, 'text')
                            }}</span>
                            <span
                                v-if="order.status < 5"
                                class="data"
                                style="display: flex; align-items: center; justify-content: flex-start"
                                ><a style="font-size: 30px; margin-right: 15px">🕒</a>{{ formatRemainingTime() }}</span
                            >
                        </div>
                    </span>

                    <span class="infoContainer_data">
                        <label class="header">Тип ТС</label>
                        <div class="info">
                            <span class="data">{{ order.transport }}</span>
                        </div>
                    </span>
                </div>

                <div class="body__mapContainer">
                    <div style="display: flex; flex-flow: row">
                        <div class="tgisMap">
                            <MapShowcase v-if="order.address" :addresses="addrToList(order.address)" />
                        </div>
                        <div v-if="order.address" class="address_pool">
                            <a>
                                {{ order.address.from }}
                                <p v-if="order.floor">{{ 'Этаж: ' + order.floor.from }}</p>
                                <p v-if="order.is_elevator">
                                    {{
                                        'Лифт: ' +
                                        (order.is_elevator.from
                                            ? 'в наличии' + (order.is_cargo_elevator.from ? ', с грузовым' : '')
                                            : 'отсутствует')
                                    }}
                                </p>
                            </a>
                            <a v-for="(item, index) in order.address.middle" :key="index">
                                {{ item }}
                                <p v-if="order.floor">{{ 'Этаж: ' + order.floor.middle[index] }}</p>
                                <p v-if="order.is_elevator">
                                    {{
                                        'Лифт: ' +
                                        (order.is_elevator.middle[index] == 'true'
                                            ? 'в наличии' +
                                              (order.is_cargo_elevator.middle[index] == 'true' ? ', с грузовым' : '')
                                            : 'отсутствует')
                                    }}
                                </p>
                            </a>
                            <a>
                                {{ order.address.to }}
                                <p v-if="order.floor">{{ 'Этаж: ' + order.floor.to }}</p>
                                <p v-if="order.is_elevator">
                                    {{
                                        'Лифт: ' +
                                        (order.is_elevator.to
                                            ? 'в наличии' + (order.is_cargo_elevator.to ? ', с грузовым' : '')
                                            : 'отсутствует')
                                    }}
                                </p>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="editing_container__functions">
                <!-- TODOFRONT table -->
                <span
                    v-if="carriers.length <= 0"
                    style="font-size: 25px; position: absolute; display: flex; margin-top: 10%"
                    >Пусто</span
                >
                <div class="requests_fromExecutor" v-for="carrier in carriers" :key="carrier.name">
                    <label class="fromExecutor__label">
                        <a>{{ carrier.name }}</a>
                        <p>{{ carrier.phone }}</p>
                        <p class="desc" v-if="carrier.comment && carrier.comment != ''">
                            Комментарий: {{ carrier.comment }}
                        </p>
                        <p v-if="carrier.cost && carrier.cost != 0">Цена: {{ carrier.cost }} руб.</p>
                    </label>
                    <span style="display: flex" v-if="carrier.cost && (!order.executor || !order.executor.fullname)">
                        <button
                            v-if="carrier.cost != '0'"
                            @click="confirmRequest(carrier)"
                            id="chose"
                            type="submit"
                            value="Выбрать"
                            class="btn-reset btn btn_blue small mobile_padding_bottom"
                        >
                            Выбрать
                        </button>
                        <button
                            disabled
                            v-if="carrier.cost == '0'"
                            @click="cancelRequest(carrier)"
                            style="margin-left: 15px"
                            id="cancel"
                            type="submit"
                            value="Отказаться"
                            class="btn-reset btn btn_cancel small mobile_padding_bottom"
                        >
                            X
                        </button>
                    </span>
                    <span style="display: flex" v-if="order.executor && order.executor.fullname">
                        <button
                            disabled
                            v-if="carrier.name == order.executor.fullname"
                            class="btn-reset btn btn_blue small mobile_padding_bottom"
                        >
                            Выбран
                        </button>
                        <button
                            disabled
                            v-else-if="carrier.cost && carrier.cost == '0'"
                            style="margin-left: 15px"
                            id="cancel"
                            type="submit"
                            value="Отказаться"
                            class="btn-reset btn btn_cancel small mobile_padding_bottom"
                        >
                            X
                        </button>
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import tools from '@/assets/js/tools.js';
import MapShowcase from './MapShowcase.vue';
import popup from './ModalComponent.vue';

export default {
    components: {
        MapShowcase,
        PopupWindow: popup,
    },
    data() {
        return {
            order: {},
            carriers: {},
            remainingTime: {
                days: 0,
                hours: 0,
                minutes: 0,
            },
            tools: tools,
            modal: {
                popupName: 'default',
                header: 'Подтверждение',
                info: '',
                color: '#0ECCAA',
                button: '',
                button2: '',
                callback: function () {},
            },
            isVisiblePopup: false,
            timeoutId: null,
        };
    },
    methods: {
        formatRemainingTime() {
            if (this.remainingTime.days > 0) {
                return `${this.remainingTime.days} ${tools.getDaysWord(this.remainingTime.days)}`;
            } else if (this.remainingTime.hours > 0) {
                return `${this.remainingTime.hours} ${tools.getHoursWord(this.remainingTime.hours)}`;
            } else {
                return `${this.remainingTime.minutes} ${tools.getMinutesWord(this.remainingTime.minutes)}`;
            }
        },
        updateRemainingTime() {
            let vm = this;
            const currentTimeMilliseconds = new Date().getTime();
            const timeDifferenceMilliseconds = vm.order.date_start - currentTimeMilliseconds;

            vm.remainingTime.days = Math.floor(timeDifferenceMilliseconds / (1000 * 3600 * 24));
            vm.remainingTime.hours = Math.floor((timeDifferenceMilliseconds % (1000 * 3600 * 24)) / (1000 * 3600));
            vm.remainingTime.minutes = Math.floor((timeDifferenceMilliseconds % (1000 * 3600)) / (1000 * 60));

            console.log(vm.order);

            vm.timeoutId = setTimeout(() => {
                vm.updateRemainingTime();
            }, 60000);
        },
        refreshPage() {
            window.location.reload(false);
        },
        closePage() {
            window.close();
        },
        progressBarForStatus(stat) {
            try {
                return {
                    0: '10',
                    2: '50',
                    3: '60',
                    4: '70',
                }[stat];
            } catch {
                return '100';
            }
        },
        confirmActionPopup(header, info, callback) {
            let vm = this;
            vm.modal = {
                popupName: 'default',
                header: header,
                info: info,
                button: 'Да',
                button2: 'Нет',
                color: '#0ECCAA',
                callback: function (element) {
                    if (element === 'Да') {
                        callback();
                    }
                    vm.isVisiblePopup = false;
                },
            };
            vm.isVisiblePopup = true;
        },
        editingOrder() {
            let vm = this;
            vm.modal = {
                popupName: 'editingOrder',
                header: 'Редактирование заказа # ' + vm.order.id,
                info: 'Измените поля которые хотите отредактировать?',
                button: 'Изменить',
                button2: 'Отменить',
                color: '#0ECCAA',
                callback: function (element, why, data) {
                    if (data) {
                        var formatedData = {
                            order_id: data.id,
                            dateTimeStart: data.date_start,
                            contactName: data.contactName,
                            contactPhone: data.contactPhone,
                            weight: data.weight,
                            gender: data.gender,
                            age: data.age,
                            state: data.state,
                            mobility: data.mobility,
                            comment: data.comment,
                            transport: data.transport,
                            isReturn: data.isReturn,
                            isWait: data.isWait,
                            nnWaitTime: data.nnWaitTime,
                            isPregnant: data.isPregnant,
                            orderPrice: data.price,
                        };
                    }

                    if (element === 'Изменить') {
                        vm.changeOrderData(formatedData);
                    }

                    vm.isVisiblePopup = false;
                },
            };
            vm.isVisiblePopup = true;
        },
        cancelOrder(who) {
            let vm = this;
            let orderData = {
                order_id: vm.order.id,
                owner_id: '',
                type: who,
            };

            if (who === 'user') {
                orderData.owner_id = '';
            } else {
                orderData.owner_id = '';
            }

            vm.confirmActionPopup('Отмена', 'Хотите отменить заказ?', () =>
                $.ajax({
                    type: 'GET',
                    url: global.BACKEND_URL + `/admin/cancel_order?order_id=${vm.order.id}`,
                    xhrFields: { withCredentials: true },
                    data: orderData,
                    success: function () {
                        vm.refreshPage();
                    },
                    error: function () {},
                    dataType: 'text',
                    contentType: 'application/json',
                })
            );
        },
        changeStatusOrder(newStatus) {
            let vm = this;
            var info = "Хотите перевести заказ в статус 'В работе'?";
            if (newStatus == 5) {
                info = 'Хотите подтвердить выполнение заказа?';
            }
            vm.confirmActionPopup('Новый статус', info, () =>
                $.ajax({
                    type: 'GET',
                    url: global.BACKEND_URL + `/admin/get_next_status?order_id=${vm.order.id}&type=${newStatus}`, // TODOBACK try
                    xhrFields: { withCredentials: true },
                    success: function () {
                        vm.refreshPage();
                    },
                    error: function () {},
                    dataType: 'text',
                    contentType: 'application/json',
                })
            );
        },
        removeOrder() {
            let vm = this;
            vm.confirmActionPopup('Удаление заказа', 'Подтверждаете удаление заказа?', () =>
                $.ajax({
                    type: 'GET',
                    url: global.BACKEND_URL + `/admin/delete_order?order_id=${vm.order.id}`,
                    xhrFields: { withCredentials: true },
                    success: function () {
                        vm.closePage();
                    },
                    error: function () {},
                    dataType: 'text',
                    contentType: 'application/json',
                })
            );
        },
        alertOrder() {
            let vm = this;
            vm.confirmActionPopup('Уведомление', 'Хотите заново послать уведомление заказу?', () =>
                $.ajax({
                    type: 'GET',
                    url: global.BACKEND_URL + `/admin/repeat_last_email?order_id=${vm.order.id}`, // TODOBACK
                    xhrFields: { withCredentials: true },
                    success: function () {},
                    error: function () {},
                    dataType: 'text',
                    contentType: 'application/json',
                })
            );
        },
        saveEditOrder(data) {
            let vm = this;
            $.ajax({
                type: 'GET',
                url: global.BACKEND_URL + `/admin/change_order_data`, // TODOBACK try
                xhrFields: { withCredentials: true },
                data: data,
                success: function () {
                    vm.refreshPage();
                },
                error: function () {},
                dataType: 'text',
                contentType: 'application/json',
            });
        },
        printOrder() {
            window.print();
        },
        confirmRequest(request) {
            let vm = this;
            vm.confirmActionPopup('Перевозчик ' + request.name, 'Подтвердить предложение от перевозчика?', () =>
                $.ajax({
                    type: 'GET',
                    url: global.BACKEND_URL + `/admin/choose_owner?order_id=${vm.order.id}&owner_name=${request.name}`,
                    xhrFields: { withCredentials: true },
                    success: function () {
                        vm.refreshPage();
                    },
                    error: function () {},
                    dataType: 'text',
                    contentType: 'application/json',
                })
            );
        },
        addrToList(addr) {
            var { from, to, middle } = addr;
            if (!middle) {
                middle = [];
            }
            return [from, ...middle, to];
        },
        renderCarriers() {
            let vm = this;
            let orderID = this.$route.params.id;

            $.ajax({
                type: 'GET',
                xhrFields: { withCredentials: true },
                url: global.BACKEND_URL + `/admin/get_owner_responses?order_id=${orderID}`,
                success: function (data) {
                    vm.carriers = data;
                    vm.carriers.sort((a, b) => {
                        const sortingType = -1;
                        if (a.cost == '0' && b.cost == '0') return 0;
                        if (a.cost == '0') return -sortingType;
                        if (b.cost == '0') return sortingType;
                        if (!a.cost && !b.cost) return 0;
                        if (!a.cost) return -sortingType;
                        if (!b.cost) return sortingType;
                        if (vm.order.executor && a.name == vm.order.executor.fullname) return sortingType;
                        return -sortingType;
                    });
                },
                error: function () {},
                dataType: 'json',
                contentType: 'application/json',
            });
        },
        changeOrderData(data) {
            let vm = this;
            let formatedData = {
                order_id: data.order_id,
                dateTimeStart: data.dateTimeStart,
                contactName: data.contactName,
                contactPhone: data.contactPhone,
                age: data.age.toLowerCase() == 'взрослый' ? '24' : '16',
                comment: data.comment,
                gender: data.gender.toLowerCase() == 'мужской' ? 'male' : 'female',
                isPregnant: data.isPregnant,
                isReturn: data.isReturn,
                isWait: data.isWait,
                mobility: data.mobility,
                nnWaitTime: data.nnWaitTime,
                price: data.orderPrice,
                state:
                    data.state.toLowerCase() == 'удовлетворительное'
                        ? 'v1'
                        : data.state == 'средней тяжести'
                        ? 'v2'
                        : 'v3',
                transport:
                    data.transport.toLowerCase() == 'машина'
                        ? '11'
                        : data.transport == 'жд'
                        ? '41'
                        : data.transport == 'самолет'
                        ? '21'
                        : '31',
                weight: data.weight,
            };

            vm.saveEditOrder(formatedData);
        },
        getOrderData() {
            let vm = this;
            let orderID = this.$route.params.id;

            $.ajax({
                type: 'GET',
                xhrFields: { withCredentials: true },
                url: global.BACKEND_URL + `/admin/get_order_info?order_id=` + orderID,
                success: function (data) {
                    vm.has_loaded_once = true;
                    if (data) {
                        vm.order = {
                            id: data['id'],
                            date_created: data['date_created'],
                            price: data['price'],
                            date_start: data['date_start'],
                            region: data['region'],
                            address: data['address'],
                            transport: data['transport'],
                            customer: data['customer'],
                            executor: data['executor'],
                            status: data['status'],
                            isWait: data['isWait'],
                            isReturn: data['isReturn'],
                            nnWaitTime: data['nnWaitTime'],
                            contactName: data['contactName'],
                            contactPhone: data['contactPhone'],
                            weight: data['weight'],
                            gender: data['gender'] == 'male' ? 'Мужской' : 'Женский',
                            isPregnant: data['isPregnant'],
                            age: data['age'] == '16' ? 'Ребёнок' : 'Взрослый',
                            state:
                                data['state'] == 'v1'
                                    ? 'Удовлетворительное'
                                    : data['state'] == 'v2'
                                    ? 'Средней тяжести'
                                    : 'Крайне тяжелое',
                            is_cargo_elevator: data['is_cargo_elevator'],
                            floor: data['floor'],
                            is_elevator: data['is_elevator'],
                            mobility: data['mobility'],
                            comment: data['comment'],
                            istg: data['istg'], // TODOBACK
                        };
                        vm.updateRemainingTime();
                    }
                },
                error: function () {},
            });
        },
    },
    mounted() {
        let vm = this;
        vm.getOrderData();
        vm.renderCarriers();

        setInterval(() => {
            vm.renderCarriers();
        }, 5000);
    },
    beforeUnmount() {
        clearTimeout(this.timeoutId);
    },
};
</script>

<style scoped src="@/assets/css/editing_page.css"></style>
